export const createSubmittedObject = (values: any) => {
  const returnObject: any = values;

  const checkboxFields = [
    "ecs_nat_instance",
    "use_motion",
    "use_v5",
    "use_nx_proxy",
  ];

  checkboxFields.forEach((field) => {
    if (returnObject[field] === "True") {
      returnObject[field] = true;
    }
    if (returnObject[field] === "False") {
      returnObject[field] = false;
    }
  });

  returnObject.integration = localStorage.integrationType;

  return returnObject;
};
